import { isEmptyNullUndef } from '../services/util';
import { trim } from 'lodash';

export const NATURE_OF_BIZ = 'MATCHING_TOKENS_IN_NATURE_OF_BUSINESS';

export const transformFeatureValue = (feature) => {
  let currentClusterFeatureScore = '';
  const featureName =
    feature?.name && feature.name.toUpperCase().replace(/\s+/g, '_');
  console.log('feature.name');
  console.log(featureName);

  if (featureName === NATURE_OF_BIZ) {
    if (isEmptyNullUndef(feature.featureValue)) {
      return 'No token found';
    } else {
      return trim(feature.featureValue);
    }
  }

  if (featureName === 'AGE_DIFFERENCE') {
    const ageDifferenceValue = Number(feature.featureValue);

    if (ageDifferenceValue < 0) {
      currentClusterFeatureScore = 'Insufficient Information';
      return currentClusterFeatureScore;
    }

    return ageDifferenceValue;
  }

  if (featureName === 'INFERRED_MINIMUM_AGE') {
    const age = Number(feature.featureValue);
    if (Number.isNaN(age)) {
      return '-';
    }
    return age > 1 ? `${age} Yrs` : `${age} Yr`;
  }

  if (featureName === 'FIRST_CHARACTER_MATCH') {
    const firstCharacterMatchValue = Number(feature.featureValue);

    if (firstCharacterMatchValue === 0) {
      currentClusterFeatureScore = 'Mismatch';
      return currentClusterFeatureScore;
    } else if (firstCharacterMatchValue === 1) {
      currentClusterFeatureScore = 'Match';
      return currentClusterFeatureScore;
    } else {
      currentClusterFeatureScore = 'Insufficient Information';
      return currentClusterFeatureScore;
    }
  }

  if (featureName === 'FIRST_CHARACTER_WATCHLIST_IN_CUSTOMER_NAME') {
    const firstCharacterMatchCustomerNameValue = Number(feature.featureValue);

    if (firstCharacterMatchCustomerNameValue === 0) {
      currentClusterFeatureScore = 'Mismatch';
      return currentClusterFeatureScore;
    } else if (firstCharacterMatchCustomerNameValue === 1) {
      currentClusterFeatureScore = 'Match';
      return currentClusterFeatureScore;
    } else {
      currentClusterFeatureScore = 'Insufficient Information';
      return currentClusterFeatureScore;
    }
  }

  if (
    featureName === 'FIRST_CHARACTER_MATCH_BETWEEN_CUSTOMER_AND_WATCHLIST_NAME'
  ) {
    const firstCharMatchWatchlistNameValue = Number(feature.featureValue);

    if (firstCharMatchWatchlistNameValue === 0) {
      currentClusterFeatureScore = 'Mismatch';
      return currentClusterFeatureScore;
    } else if (firstCharMatchWatchlistNameValue === 1) {
      currentClusterFeatureScore = 'Match';
      return currentClusterFeatureScore;
    } else {
      currentClusterFeatureScore = 'Insufficient Information';
      return currentClusterFeatureScore;
    }
  }

  if (featureName === 'FIRST_CHARACTER_WATCHLIST_NAME_IN_CUSTOMER_NAME') {
    const firstCharMatchWatchlistNameCustomerNameValue = Number(
      feature.featureValue
    );

    if (firstCharMatchWatchlistNameCustomerNameValue === 0) {
      currentClusterFeatureScore = 'Mismatch';
      return currentClusterFeatureScore;
    } else if (firstCharMatchWatchlistNameCustomerNameValue === 1) {
      currentClusterFeatureScore = 'Match';
      return currentClusterFeatureScore;
    } else {
      currentClusterFeatureScore = 'Insufficient Information';
      return currentClusterFeatureScore;
    }
  }

  if (featureName === 'BUYER/SELLER_COUNTRY_MATCH') {
    const buyerSellerCountryMatchValue = Number(feature.featureValue);

    if (buyerSellerCountryMatchValue === 0) {
      currentClusterFeatureScore = 'Mismatch';
      return currentClusterFeatureScore;
    } else if (buyerSellerCountryMatchValue === 1) {
      currentClusterFeatureScore = 'Match';
      return currentClusterFeatureScore;
    } else {
      currentClusterFeatureScore = 'Insufficient Information';
      return currentClusterFeatureScore;
    }
  }

  if (
    featureName ===
    'INDUSTRY_KEYWORD_MATCH_BETWEEN_CUSTOMER_NAME_AND_WATCHLIST_NAME'
  ) {
    const industryKeywordWatchlistNameValue = Number(feature.featureValue);

    if (industryKeywordWatchlistNameValue === 0) {
      currentClusterFeatureScore = 'Mismatch';
      return currentClusterFeatureScore;
    } else if (industryKeywordWatchlistNameValue === 1) {
      currentClusterFeatureScore = 'Match';
      return currentClusterFeatureScore;
    } else {
      currentClusterFeatureScore = 'Insufficient Information';
      return currentClusterFeatureScore;
    }
  }

  if (
    featureName ===
    'INDUSTRY_KEYWORD_MATCH_BETWEEN_NATURE_OF_BUSINESS_AND_WATCHLIST_NAME'
  ) {
    const industryKeywordNatureOfBusinessWatchlistNameValue = Number(
      feature.featureValue
    );

    if (industryKeywordNatureOfBusinessWatchlistNameValue === 0) {
      currentClusterFeatureScore = 'Mismatch';
      return currentClusterFeatureScore;
    } else if (industryKeywordNatureOfBusinessWatchlistNameValue === 1) {
      currentClusterFeatureScore = 'Match';
      return currentClusterFeatureScore;
    } else {
      currentClusterFeatureScore = 'Insufficient Information';
      return currentClusterFeatureScore;
    }
  }

  if (featureName === 'YEAR_OF_INCORPORATION_DIFFERENCE') {
    const yearOfIncorporationDifferenceValue = Number(feature.featureValue);

    if (yearOfIncorporationDifferenceValue < 0) {
      currentClusterFeatureScore = 'Insufficient Information';
      return currentClusterFeatureScore;
    }

    return yearOfIncorporationDifferenceValue;
  }

  if (featureName === 'COUNTRY_OF_BIRTH_MATCH') {
    const cobValue = Number(feature.featureValue);

    if (cobValue === 0) {
      currentClusterFeatureScore = 'Mismatch';
      return currentClusterFeatureScore;
    } else if (cobValue === 1) {
      currentClusterFeatureScore = 'Match';
      return currentClusterFeatureScore;
    } else {
      currentClusterFeatureScore = 'Insufficient Information';
      return currentClusterFeatureScore;
    }
  }

  if (featureName === 'GENDER_MATCH') {
    const genderValue = Number(feature.featureValue);

    if (genderValue === 0) {
      currentClusterFeatureScore = 'Mismatch';
      return currentClusterFeatureScore;
    } else if (genderValue === 1) {
      currentClusterFeatureScore = 'Match';
      return currentClusterFeatureScore;
    } else {
      currentClusterFeatureScore = 'Insufficient Information';
      return currentClusterFeatureScore;
    }
  }

  if (featureName === 'NATIONALITY_MATCH') {
    const nationalityValue = Number(feature.featureValue);

    if (nationalityValue === 0) {
      currentClusterFeatureScore = 'Mismatch';
      return currentClusterFeatureScore;
    } else if (nationalityValue === 1) {
      currentClusterFeatureScore = 'Match';
      return currentClusterFeatureScore;
    } else {
      currentClusterFeatureScore = 'Insufficient Information';
      return currentClusterFeatureScore;
    }
  }

  if (featureName === 'COUNTRY_OF_INCORPORATION_MATCH') {
    const coiValue = Number(feature.featureValue);

    if (coiValue === 0) {
      currentClusterFeatureScore = 'Mismatch';
      return currentClusterFeatureScore;
    } else if (coiValue === 1) {
      currentClusterFeatureScore = 'Match';
      return currentClusterFeatureScore;
    } else {
      currentClusterFeatureScore = 'Insufficient Information';
      return currentClusterFeatureScore;
    }
  }

  if (featureName === 'BUYER_COUNTRY_MATCH_SCORE') {
    const buyerCountryValue = Number(feature.featureValue);

    if (buyerCountryValue === 0) {
      currentClusterFeatureScore = 'Mismatch';
      return currentClusterFeatureScore;
    } else if (buyerCountryValue === 1) {
      currentClusterFeatureScore = 'Match';
      return currentClusterFeatureScore;
    } else {
      currentClusterFeatureScore = 'Insufficient Information';
      return currentClusterFeatureScore;
    }
  }

  if (featureName === 'AGE_GREATER_THAN_MINIMUM_AGE') {
    const ageGreaterThanMinimumValue = Number(feature.featureValue);

    if (ageGreaterThanMinimumValue === 0) {
      currentClusterFeatureScore = 'No';
      return currentClusterFeatureScore;
    } else if (ageGreaterThanMinimumValue === 1) {
      currentClusterFeatureScore = 'Yes';
      return currentClusterFeatureScore;
    } else {
      currentClusterFeatureScore = 'Insufficient Information';
      return currentClusterFeatureScore;
    }
  }

  if (
    featureName === 'FINAL_SYNONYM_MATCH' ||
    featureName === 'NUMBER_OF_MATCHING_TOKENS' ||
    featureName === 'NUMBER_OF_TOKEN_IN_CUSTOMER_NAME' ||
    featureName === 'NUMBER_OF_TOKEN_IN_WATCHPERSON_NAME' ||
    featureName === 'CUSTOMER_AGE'
  ) {
    return Number(feature.featureValue).toFixed();
  }

  return !Number.isNaN(feature.featureValue)
    ? Number(feature.featureValue).toFixed(2)
    : feature.featureValue;
};
